export const noop = () => {}
